import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_register_endorser_modal_bibo",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": false,
  "data-bs-keyboard": false
}
const _hoisted_2 = { class: "modal-dialog mw-1000px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body scroll-y m-5" }
const _hoisted_8 = {
  ref: "createAccountRef",
  class: "stepper stepper-links d-flex flex-column",
  id: "kt_create_account_stepper"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"stepper-nav py-5\"><div class=\"stepper-item current\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\"> Account Info </h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\"> Confirmation </h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\"> Completed </h3></div></div>", 1)
const _hoisted_10 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_11 = { class: "w-100" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "pb-10 pb-lg-15" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-6" }, " Please fill-up all the information correctly. ")
], -1)
const _hoisted_13 = { class: "row mb-10" }
const _hoisted_14 = { class: "col-md-6 fv-row" }
const _hoisted_15 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "First Name"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Your First Name"
  })
], -1)
const _hoisted_17 = { class: "position-relative" }
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "col-md-6 fv-row" }
const _hoisted_21 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_22 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", null, "Middle Name")
], -1)
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "col-md-6 fv-row" }
const _hoisted_26 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_27 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Last Name", -1)
const _hoisted_28 = { class: "position-relative" }
const _hoisted_29 = { class: "fv-plugins-message-container" }
const _hoisted_30 = { class: "fv-help-block" }
const _hoisted_31 = { class: "col-md-6 fv-row" }
const _hoisted_32 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_33 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Birth Date", -1)
const _hoisted_34 = { class: "position-relative" }
const _hoisted_35 = { class: "fv-plugins-message-container" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = { class: "row mb-10" }
const _hoisted_38 = { class: "col-md-12 fv-row" }
const _hoisted_39 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Account Access", -1)
const _hoisted_40 = { class: "row fv-row" }
const _hoisted_41 = { class: "col-12" }
const _hoisted_42 = { class: "fv-plugins-message-container" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { class: "col-6" }
const _hoisted_45 = { class: "fv-plugins-message-container" }
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "fs-7 fw-bold text-gray-400" }, " Password ", -1)
const _hoisted_48 = { class: "col-6" }
const _hoisted_49 = { class: "fv-plugins-message-container" }
const _hoisted_50 = { class: "fv-help-block" }
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "fs-7 fw-bold text-gray-400" }, " Confirm Password ", -1)
const _hoisted_52 = { class: "w-100" }
const _hoisted_53 = { class: "row mb-10" }
const _hoisted_54 = { class: "col-md-6 fv-row" }
const _hoisted_55 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_56 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "User ID"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: ""
  })
], -1)
const _hoisted_57 = { class: "fv-plugins-message-container" }
const _hoisted_58 = { class: "fv-help-block" }
const _hoisted_59 = { class: "col-md-6 fv-row" }
const _hoisted_60 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_61 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "PIN"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: ""
  })
], -1)
const _hoisted_62 = { class: "fv-plugins-message-container" }
const _hoisted_63 = { class: "fv-help-block" }
const _hoisted_64 = { "data-kt-stepper-element": "content" }
const _hoisted_65 = { class: "w-100" }
const _hoisted_66 = { class: "mb-0" }
const _hoisted_67 = {
  key: 0,
  class: "notice d-flex bg-light-warning rounded border-warning border border-dashed p-6"
}
const _hoisted_68 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_69 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-stack flex-grow-1\"><div class=\"fw-bold\"><h4 class=\"text-gray-800 fw-bolder\"> Please wait... verifying data... </h4><div class=\"fs-6 text-gray-600\"><a href=\"javascript:;\" class=\"fw-bolder\"></a></div></div></div>", 1)
const _hoisted_70 = /*#__PURE__*/_createStaticVNode("<div data-kt-stepper-element=\"content\"><div class=\"w-100 text-center\"><h1 class=\"fw-bolder text-dark mb-3\"></h1><div class=\"text-muted fw-bold fs-3\"> Submitting your application. Please wait </div><div class=\"text-center px-4 py-15\"><img src=\"media/illustrations/todo.png\" alt=\"\" class=\"mw-100 mh-150px\"></div></div></div>", 1)
const _hoisted_71 = { class: "d-flex flex-stack pt-15" }
const _hoisted_72 = { class: "me-2" }
const _hoisted_73 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_75 = { key: 0 }
const _hoisted_76 = {
  key: 0,
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_77 = { class: "indicator-label" }
const _hoisted_78 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_79 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_80 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_81 = {
  key: 1,
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_83 = { class: "svg-icon svg-icon-3 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_ConfirmRegisterBiboEndorser = _resolveComponent("ConfirmRegisterBiboEndorser")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h2", null, "BIBO Endorser Registration " + _toDisplayString(_ctx.bibo_codeid), 1),
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode("form", {
              class: "mx-auto mw-600px w-100 py-10",
              novalidate: "novalidate",
              id: "kt_create_account_form",
              onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
            }, [
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode("div", _hoisted_13, [
                    _createVNode("div", _hoisted_14, [
                      _createVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createVNode("div", _hoisted_17, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_firstName"
                          }),
                          _createVNode("div", _hoisted_18, [
                            _createVNode("div", _hoisted_19, [
                              _createVNode(_component_ErrorMessage, { name: "insured_firstName" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_20, [
                      _createVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "",
                          name: "insured_middleName",
                          maxlength: "50"
                        }),
                        _createVNode("div", _hoisted_23, [
                          _createVNode("div", _hoisted_24, [
                            _createVNode(_component_ErrorMessage, { name: "insured_middleName" })
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_25, [
                      _createVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createVNode("div", _hoisted_28, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_lastName"
                          }),
                          _createVNode("div", _hoisted_29, [
                            _createVNode("div", _hoisted_30, [
                              _createVNode(_component_ErrorMessage, { name: "insured_lastName" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_31, [
                      _createVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _createVNode("div", _hoisted_34, [
                          _createVNode(_component_Field, {
                            type: "date",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_birthday",
                            format: "DD/MM/yyyy"
                          }),
                          _createVNode("div", _hoisted_35, [
                            _createVNode("div", _hoisted_36, [
                              _createVNode(_component_ErrorMessage, { name: "insured_birthday" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_37, [
                    _createVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createVNode("div", _hoisted_40, [
                        _createVNode("div", _hoisted_41, [
                          _createVNode(_component_Field, {
                            name: "username",
                            class: "form-control form-control-solid",
                            type: "text",
                            placeholder: "Username"
                          }),
                          _createVNode("div", _hoisted_42, [
                            _createVNode("div", _hoisted_43, [
                              _createVNode(_component_ErrorMessage, { name: "username" })
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_44, [
                          _createVNode(_component_Field, {
                            name: "password",
                            class: "form-control form-control-solid",
                            type: "password",
                            placeholder: "Password"
                          }),
                          _createVNode("div", _hoisted_45, [
                            _createVNode("div", _hoisted_46, [
                              _createVNode(_component_ErrorMessage, { name: "password" })
                            ])
                          ]),
                          _hoisted_47
                        ]),
                        _createVNode("div", _hoisted_48, [
                          _createVNode(_component_Field, {
                            name: "cpassword",
                            class: "form-control form-control-solid",
                            type: "password",
                            placeholder: "Confirm Password"
                          }),
                          _createVNode("div", _hoisted_49, [
                            _createVNode("div", _hoisted_50, [
                              _createVNode(_component_ErrorMessage, { name: "cpassword" })
                            ])
                          ]),
                          _hoisted_51
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_52, [
                    _createVNode("div", _hoisted_53, [
                      _createVNode("div", _hoisted_54, [
                        _createVNode("div", _hoisted_55, [
                          _hoisted_56,
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "userid",
                            maxlength: "20"
                          }),
                          _createVNode("div", _hoisted_57, [
                            _createVNode("div", _hoisted_58, [
                              _createVNode(_component_ErrorMessage, { name: "userid" })
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_59, [
                        _createVNode("div", _hoisted_60, [
                          _hoisted_61,
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "securitypin",
                            maxlength: "20"
                          }),
                          _createVNode("div", _hoisted_62, [
                            _createVNode("div", _hoisted_63, [
                              _createVNode(_component_ErrorMessage, { name: "securitypin" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_64, [
                _createVNode("div", _hoisted_65, [
                  _createVNode("div", _hoisted_66, [
                    (_ctx.formData.verifyingdata)
                      ? (_openBlock(), _createBlock("div", _hoisted_67, [
                          _createVNode("span", _hoisted_68, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                          ]),
                          _hoisted_69
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.formData.verifyingdata === false)
                      ? (_openBlock(), _createBlock(_component_ConfirmRegisterBiboEndorser, {
                          key: 1,
                          formdata: _ctx.formData,
                          userFname: _ctx.user.fname
                        }, null, 8, ["formdata", "userFname"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _hoisted_70,
              _createVNode("div", _hoisted_71, [
                _createVNode("div", _hoisted_72, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-lg btn-light-primary me-3",
                    "data-kt-stepper-action": "previous",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.previousStep()))
                  }, [
                    _createVNode("span", _hoisted_73, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Left-2.svg" })
                    ]),
                    _hoisted_74
                  ])
                ]),
                (_ctx.formData.verifyingdata === false && _ctx.currentStepIndex < (_ctx.totalSteps))
                  ? (_openBlock(), _createBlock("div", _hoisted_75, [
                      (_ctx.currentStepIndex === 1)
                        ? (_openBlock(), _createBlock("button", _hoisted_76, [
                            _createVNode("span", _hoisted_77, [
                              _hoisted_78,
                              _createVNode("span", _hoisted_79, [
                                _createVNode(_component_inline_svg, { src: "icons/duotone/Navigation/Right-2.svg" })
                              ])
                            ]),
                            _hoisted_80
                          ]))
                        : (_openBlock(), _createBlock("button", _hoisted_81, [
                            _hoisted_82,
                            _createVNode("span", _hoisted_83, [
                              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Right-2.svg" })
                            ])
                          ]))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 32)
          ], 512)
        ])
      ])
    ])
  ]))
}